import type { BusinessHours } from '../../interfaces/common/business-hours';

export const BUSINESS_HOURS_KEYS: (keyof BusinessHours)[] = [
  'weekday',
  'saturday',
  'sunday',
];
